import { Component, Input } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import {
    MatCardContent,
    MatCardHeader,
    MatCardModule,
} from '@angular/material/card';
import {
    DatePipe,
    NgClass,
    NgFor,
    NgIf,
    NgStyle,
    TitleCasePipe,
} from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ChatItemMessage } from 'src/app/models/ai-chat-models/chat.model';
import { Me } from 'src/app/models/me.model';
import {
    AI_ASSISTANT_ROLE,
    USER_ROLE,
} from 'src/app/constants/settingContants';
import { MarkdownModule } from 'ngx-markdown';

@Component({
    selector: 'app-chat-message',
    templateUrl: './chat-message.component.html',
    styleUrls: ['./chat-message.component.scss'],
    imports: [
        MatChipsModule,
        MatCardModule,
        MatCardHeader,
        MatCardContent,
        MatIconModule,
        NgClass,
        NgIf,
        NgFor,
        DatePipe,
        TitleCasePipe,
        MarkdownModule,
    ],
})
export class ChatMessageComponent {
    @Input() msg: ChatItemMessage;
    @Input() predecessor: ChatItemMessage;
    @Input() localUser: { userData: Me; photo: string };
    AI_ASSISTANT_ROLE = AI_ASSISTANT_ROLE;
    USER_ROLE = USER_ROLE;

    constructor() {}

    protected getDateDivider(msg: ChatItemMessage): string {
        if (!msg.createdAt) {
            return null;
        }

        return msg.createdAt;
    }

    protected getUserName(role: string): string {
        return role === USER_ROLE
            ? this.localUser.userData.firstName
            : AI_ASSISTANT_ROLE;
    }

    protected getCreatedDate(msg: ChatItemMessage): string {
        if (!msg.createdAt) {
            return null;
        }

        return msg.createdAt.toString();
    }

    protected isPredecessorSameAuthor(): boolean {
        if (!this.predecessor) {
            return false;
        }

        return this.predecessor.id === this.msg.id;
    }

    protected isPreviousMessageFromOtherDay() {
        if (!this.predecessor) {
            return true;
        }

        return false;
    }
}
